const { removeTrapFocus, trapFocus } = require('./global');

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.idModal = this.getAttribute('data-toggle-modal');
    if (this.idModal) {
      this.modal = document.querySelector(`#${this.idModal}`);
    }
    this.addEventListener('click', this.onSummaryClick.bind(this));
  }

  isOpen() {
    return this.modal.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.modal.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.modal.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(this.modal.querySelector('[tabindex="-1"]'), this.modal.querySelector('input:not([type="hidden"])'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.toggler : null);
    this.modal.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
